import { ToggleButtonProps } from '@mui/material';
import { alpha, Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

const COLORS = ['primary', 'secondary', 'info', 'success', 'warning', 'error'] as const;

export default function ToggleButton(theme: Theme) {
  const rootStyle = (ownerState: ToggleButtonProps) => {
    const standardColor = ownerState.color === 'standard';

    const defaultStyle = {
      ...(standardColor && {
        '&.Mui-selected': {
          borderColor: 'inherit',
        },
      }),
    };

    const colorStyle = COLORS.map((color) => ({
      ...(ownerState.color === color && {
        '&:hover': {
          borderColor: alpha(theme.palette[color].main, 0.48),
          backgroundColor: alpha(theme.palette[color].main, theme.palette.action.hoverOpacity),
        },
        '&.Mui-selected': {
          borderColor: theme.palette[color].main,
        },
      }),
    }));

    const disabledState = {
      '&.Mui-disabled': {
        '&.Mui-selected': {
          color: theme.palette.action.disabled,
          backgroundColor: theme.palette.action.selected,
          borderColor: theme.palette.action.disabledBackground,
        },
      },
    };

    return [...colorStyle, defaultStyle, disabledState];
  };

  return {
    MuiToggleButton: {
      styleOverrides: {
        root: ({ ownerState }: { ownerState: ToggleButtonProps }) => rootStyle(ownerState),
      },
    },
    MuiToggleButtonGroup: {
      styleOverrides: {
        root: {
          borderRadius: theme.shape.borderRadius,
          backgroundColor: theme.palette.background.paper,
          border: `solid 1px ${alpha(theme.palette.grey[500], 0.16)}`,
        },
        grouped: {
          margin: 4,
          // 그룹 내 버튼도 각자 border를 유지한다.
          // (이전에는 'transparent !important'로 강제해 sx/색상 지정이 모두 무시됐음)
          borderColor: alpha(theme.palette.grey[500], 0.32),
          borderRadius: `${theme.shape.borderRadius}px !important`,
          // MUI 기본 스타일은 버튼들이 테두리를 공유하도록
          // 첫 버튼 외에 borderLeft: transparent / marginLeft:-1 을 적용한다.
          // 이 프로젝트는 버튼을 각각 독립된 박스로 표시하므로 해당 규칙을 되돌린다.
          '&:not(:first-of-type)': {
            marginLeft: 4,
            borderLeft: `solid 1px ${alpha(theme.palette.grey[500], 0.32)}`,
            borderTopLeftRadius: `${theme.shape.borderRadius}px`,
            borderBottomLeftRadius: `${theme.shape.borderRadius}px`,
          },
          '&.Mui-selected + .Mui-selected': {
            marginLeft: 4,
            borderLeft: `solid 1px ${alpha(theme.palette.grey[500], 0.32)}`,
          },
        },
      },
    },
  };
}
